import React from 'react';
import RadioButtonGroup from 'lib/components/Checkbox/RadioButtonGroup';
import { NoticeAddOnPricingConfig } from 'lib/pricing/noticeAddOns/types';
import { ADDONS_COPY, wetSigOptionLabel } from './addOnsCopy';
import {
  AffidavitType,
  allowedAffidavitTypes,
  isFirstWetSigFree,
  PaperType
} from './pricingConfig';

type AffidavitTypeSelectorProps = {
  paperType: PaperType;
  value: AffidavitType;
  onChange: (value: AffidavitType) => void;
  config: NoticeAddOnPricingConfig;
};

/**
 * Customer-facing RON vs wet-sig choice. UI-only. Enforces one affidavit type
 * per order (single radio group). Branches by hardcoded paper type.
 */
export function AffidavitTypeSelector({
  paperType,
  value,
  onChange,
  config
}: AffidavitTypeSelectorProps) {
  const allowed = allowedAffidavitTypes(paperType);

  const options = [
    allowed.includes('ron') && {
      value: 'ron' as const,
      labelText: ADDONS_COPY.ronOptionLabel,
      labelDescription: ADDONS_COPY.ronOptionDescription
    },
    allowed.includes('wet_sig') && {
      value: 'wet_sig' as const,
      labelText: wetSigOptionLabel(config, isFirstWetSigFree(paperType)),
      labelDescription: ADDONS_COPY.wetSigOptionDescription
    }
  ].filter(Boolean) as {
    value: AffidavitType;
    labelText: string;
    labelDescription: string;
  }[];

  return (
    <div className="space-y-3">
      {options.length > 1 && (
        <RadioButtonGroup
          id="affidavit-type"
          labelText={ADDONS_COPY.affidavitTypeLegend}
          options={options}
          value={value}
          onChange={onChange}
          stacked
        />
      )}
    </div>
  );
}
